export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

interface UnitDatum {
  unit: string
  value: number
}

export type UnitData = Record<string, UnitDatum>

export function getUnitData(): UnitData {
  return JSON.parse(document.querySelector('#unit_prices')!.getAttribute('data')!)
}
